var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web"},[_c('div',{staticClass:"Empty"},[_vm._m(0),_c('p',{staticClass:"text"},[_vm._v("页面丢失了...")]),_c('div',{staticClass:"btns",on:{"click":_vm.onPage}},[_c('button',{staticClass:"shopping"},[_vm._v("返回")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EmptyImage"},[_c('img',{attrs:{"src":require("../../../assets/images/cannotAccess.png"),"alt":""}})])
}]

export { render, staticRenderFns }